import { render, staticRenderFns } from "./CountryLanguageList.vue?vue&type=template&id=e0cbc994&"
import script from "./CountryLanguageList.vue?vue&type=script&lang=js&"
export * from "./CountryLanguageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports